module.exports = __webpack_public_path__ + "img/profileBackground.1769f59b.png";